module.exports = __webpack_public_path__ + "static/media/clearing.cefae403.svg";